// SPDX-License-Identifier: AGPL-3.0-or-later

/**
 * Pause other user-played HTML5 media when a new player starts.
 * Muted or looping videos (such as GIFs) are left alone.
 */
export function pauseOtherMediaElements(activeMedia?: HTMLMediaElement): void {
    if (typeof document === 'undefined') return;

    for (const element of document.querySelectorAll<HTMLMediaElement>('audio, video')) {
        if (element === activeMedia || element.paused) continue;
        if (element instanceof HTMLVideoElement && (element.muted || element.loop)) continue;
        element.pause();
    }
}
